const scope = "scan2";
export default scope;
